import {URLS} from "./app-urls";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {CategoryChart, DashboardCards, TotalChart} from "../models/basic/dashboard";

export class DashboardService {

    path: string;

    constructor() {
        this.path = URLS.DASHBOARD;
    }

    async getDashboardCards(): Promise<AxiosResponse<DashboardCards>> {
        const path = `${this.path}dashboard_cards/`;
        return await trackPromise(Api.get(path));
    }

    async getTotalCharts(years?: string): Promise<AxiosResponse<TotalChart>> {
        const path = `${this.path}dashboard_chart_total/`;
        const params = years?.length ? { years } : {};

        return await trackPromise(Api.get(path, {params: params}));
    }

    async getCategoryCharts(years?: number): Promise<AxiosResponse<CategoryChart>> {
        const path = `${this.path}dashboard_category_cost/`;
        const params = years ? { years } : {};

        return await trackPromise(Api.get(path, {params: params}));
    }

    async getYearsSummary(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}years_summary/`;
        return await trackPromise(Api.get(path));
    }

    async getYearsCategoryCost(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}years_summary_category_cost/`;
        return await trackPromise(Api.get(path));
    }
}
